import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';

const ParallelList = ({ items, type, action, title, width = "w-2/5" }) => {

    const actionLabel = type == 'left' ? <FaCaretRight  /> : <FaCaretLeft />;
    const order = type == 'left' ? '' : 'flex-row-reverse';

    return (
        <div className={`${width} border border-gray-700`}>
            <div className="text-lg p-2 bg-gray-900">
                { title }
            </div>
            <ul style={{ maxHeight: 500, overflowY: "scroll" }}>
                {items.map(item => {
                    const labelId = `transfer-list-item-${item.id}-label`;
                    return (
                        <li key={item.id} className={`p-2 border-b border-gray-700 hover:bg-gray-700 flex w-full ${order}`}>
                            <div id={labelId}>{ item.name } [{ item.id }]</div>
                            <button 
                                className={`bg-gray-800 text-blue-400 cursor-pointer px-2 border border-gray-700 rounded hover:bg-gray-800 ${type=='left'?'ml-auto':'mr-auto'}`} onClick={() => action(item)}>
                                {actionLabel}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default ParallelList;